
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiShift as ObiShiftElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-shift.js';
 
 
 

 
 export const ObiShift = createComponent({
   react: React,
   tagName: 'obi-shift',
   elementClass: ObiShiftElement,
   events: {
     
   }
  });
 
 